import type { CSSProperties, ReactNode } from 'react';
import { cn } from '../../lib/utils';

export interface ResourceRowProps {
  label: string;
  value: ReactNode;
  sub: ReactNode;
  pct: number;
  color: string;
  className?: string;
}

export function ResourceRow({
  label,
  value,
  sub,
  pct,
  color,
  className,
}: ResourceRowProps) {
  const fillStyle: CSSProperties = {
    width: `${Math.max(0, Math.min(100, pct))}%`,
    background: color,
  };
  return (
    <div className={cn('py-1.5', className)}>
      <div className="flex items-baseline justify-between mb-1">
        <span className="text-[11.5px] font-medium text-textMute">{label}</span>
        <span>
          <span className="font-mono text-[14px] font-bold text-text tabular-nums">
            {value}
          </span>{' '}
          <span className="font-mono text-[10.5px] text-textMute">{sub}</span>
        </span>
      </div>
      <div className="h-1 bg-surfaceAlt rounded-sm overflow-hidden">
        <div
          style={fillStyle}
          className="h-full transition-[width] duration-300"
        />
      </div>
    </div>
  );
}

ResourceRow.displayName = 'ResourceRow';

export default ResourceRow;
